import NameUndModul from "./NameUndModul/NameUndModul.vue";
import Konfiguration from "./Konfiguration/Konfiguration.vue";
import VerwendungList from "./VerwendungList/VerwendungList.vue";

export default {
  NameUndModul,
  Konfiguration,
  VerwendungList,
};
